import React, { useRef, useEffect } from 'react';
import ReactSelect, {
  OptionTypeBase,
  Props as SelectProps,
} from 'react-select';

import { useField } from '@unform/core';

interface Props extends SelectProps<OptionTypeBase> {
  name: string;
  isMulti: false | undefined;
}

const Select: React.FC<Props> = ({ name, isMulti = false, ...rest }) => {
  const selectRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);
  const style = {
    menuPortal: (provided: any) => ({ ...provided, zIndex: 9999 }),
    menu: (provided: any) => ({ ...provided, zIndex: 9999 }),
    option: (styles: any, state: any) => ({
      ...styles,
      color: state.isSelected ? '#FFF' : styles.color,
      backgroundColor: state.isSelected ? '#80a0b8' : styles.color,
      borderBottom: '1px solid rgba(0, 0, 0, 0.125)',
      ':last-child': { borderBottom: 'none' },
      '&:hover': {
        color: '#FFF',
        backgroundColor: '#80a0b8',
      },
    }),
    control: (styles: any, state: any) => ({
      ...styles,
      borderColor:
        state.isSelected || state.isFocused ? '#3f69ab' : 'rgba(0, 0, 0, 0.3)',

      '&:hover': {
        borderColor:
          state.isFocused || state.isSelected ? '#3f69ab' : 'rgba(0, 0, 0)',
      },
    }),
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (isMulti) {
          if (!ref.state.value) {
            return [];
          }
          return ref.state.value.map((option: OptionTypeBase) => option.value);
        }
        if (!ref.state.value) {
          return '';
        }
        return ref.state.value.value;
      },
    });
  }, [fieldName, registerField, isMulti]);

  return (
    <>
      <div style={{ marginTop: '5px' }}>
        <ReactSelect
          styles={style}
          isSearchable
          defaultValue={defaultValue}
          ref={selectRef}
          classNamePrefix="react-select"
          {...rest}
        />

        {!!error && <span style={{ color: 'red' }}>{error}</span>}
      </div>
    </>
  );
};

export default Select;
